import { usePageContext } from '../../../../../../providers/PageProvider';
import { compactSecondaryButtonClassName } from '../../../../../../styles';
import { ProposalCard } from '../ProposalCard';

export const ProposalSidebar = ({ onRevealTranscript }: { onRevealTranscript?: () => void }) => {
  const {
    session,
    activeTranscriptChunk,
    activeChunkProposalCounts,
    showOnlyActiveChunkProposals,
    setShowOnlyActiveChunkProposals,
    visibleProposals,
    isBusy,
    loadingMessage,
    previewProposalId,
    jumpToProposalLine,
    previewProposalTranscript,
  } = usePageContext();

  if (!session) {
    return null;
  }

  return (
    <div className="bg-[var(--color-page)] rounded-[8px] flex flex-col gap-3 max-h-[780px] overflow-auto">
      {activeTranscriptChunk ? (
        <div className="rounded-[8px] border border-[var(--color-border)] bg-[var(--color-surface)] p-3 shadow-sm">
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="font-semibold text-[var(--color-title)]">Chunk {activeTranscriptChunk.index}</div>
              <div className="text-xs text-[var(--color-text-muted)]">{activeChunkProposalCounts.total} edits</div>
            </div>
            <button
              className={compactSecondaryButtonClassName}
              onClick={() => setShowOnlyActiveChunkProposals((currentValue) => !currentValue)}
            >
              {showOnlyActiveChunkProposals ? 'Show All' : 'Show Chunk'}
            </button>
          </div>
        </div>
      ) : null}
      {isBusy ? (
        <div className="flex flex-col items-center justify-center gap-3 rounded-[8px] border border-[var(--color-border)] bg-[var(--color-surface)] p-8 text-sm text-[var(--color-text-muted)] shadow-sm">
          <span className="h-6 w-6 animate-spin rounded-full border-2 border-[var(--color-border)] border-t-[var(--color-primary)]" />
          {loadingMessage || 'Loading edits...'}
        </div>
      ) : (
        visibleProposals.map((proposal) => (
          <ProposalCard
            disabled={isBusy}
            isPreviewed={previewProposalId === proposal.id}
            key={proposal.id}
            proposal={proposal}
            onJumpToLine={(proposal) => {
              onRevealTranscript?.();
              jumpToProposalLine(proposal);
            }}
            onPreview={(proposal) => {
              onRevealTranscript?.();
              previewProposalTranscript(proposal);
            }}
          />
        ))
      )}
    </div>
  );
};
